import React, { useEffect, useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import theme from "../../helpers/theme";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";

/**
 *
 * @param {Array.<Object>} items array of display names and values for the dropdown.
 * schema: {display_name: string, value: *}
 * @param {Function} onChange handler callback when dropdown item is changed/selected
 *
 * See other props in commonProps or formProps for optional configurations
 *
 * @returns styled Select dropdown
 */
const StyledSelect = (props) => {
  // TODO: configure NativeSelect when on mobile
  const [menuItems, setMenuItems] = useState(<></>);
  const [value, setValue] = useState(
    props.defaultValue ? props.defaultValue : ""
  );
  const [defaultValue, setDefaultValue] = useState("");

  const handleChange = (event) => {
    event.stopPropagation();
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  let commonProps = {
    label: props.label,
    disabled: props.disabled ? props.disabled : false,
    sx: {
      backgroundColor: props.backgroundColor ? props.backgroundColor : "white",
      borderRadius: props.borderRadius ? props.borderRadius : 0,
      "&.Mui-disabled": {
        backgroundColor: theme.palette.secondary[100],
      },
      width: props.width ? props.width : "100%",
      height: props.height ? props.height : "100%",
    },
  };

  let formProps = {
    size: props.size ? props.size : "small",
    sx: {
      width: props.formWidth ? props.formWidth : "100%",
      height: props.formHeight ? props.formHeight : "100%",
    },
    variant: props.variant ? props.variant : "outlined",
  };

  useEffect(() => {
    if (props.value) {
      setDefaultValue(props.value);
    }
  });

  useEffect(() => {
    if (!props.items) {
      return;
    }
    const newMenuItems = props.items.map((item) => {
      return <MenuItem key={item.value} value={item.value}>{item.display_text}</MenuItem>;
    });
    setMenuItems(newMenuItems);
  }, [props.items]);

  return (
    <FormControl {...formProps}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        value={defaultValue ? defaultValue : value}
        onChange={(event) => handleChange(event)}
        IconComponent={ExpandMoreSharpIcon}
        {...commonProps}
      >
        {menuItems}
      </Select>
    </FormControl>
  );
};

export default StyledSelect;
